import React, { useEffect, useMemo, useState } from "react"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import ProvinceDashboardComponent from "components/ProvinceDashboard/ProvinceDashbaord"
import {
  exportProvinceStock,
  getProvinceItemCategories,
  getProvinceItems,
  getProvinceStock,
} from "store/province-dashboard/province-dashboard-action"
const ProvinceDashboard = props => {
  //meta title
  document.title = "Dashboard"

  const [advancedSearch, setAdvancedSearch] = useState({})

  // Retrieve province Stock data from Redux store
  const provinceStock = useSelector(
    state => state.provinceDashboard.provinceStock
  )

  // Retrieve categories data from Redux store
  const categories = useSelector(
    state => state.provinceDashboard.ProvinceItemCategoires
  )

  const dispatch = useDispatch()

  const user = useSelector(state => state.auth?.user)
  const defaultFilters = useMemo(() => {
    const ids = user?.item_categories
    return ids?.length ? { item_category_ids: ids } : {}
  }, [user?.item_categories])

  // Executes when the advanced search form is submitted
  const onAdvanceSearch = values => {
    setAdvancedSearch(values)
    dispatch(getProvinceStock(values))
  }

  // store Item Categories and fetch items based item category
  const onCategoryChange = category => {
    dispatch(getProvinceItems(category))
  }

  // fetch province inventory and other data which is need for filter
  useEffect(() => {
    dispatch(getProvinceStock(defaultFilters))
    dispatch(getProvinceItemCategories())
  }, [dispatch, defaultFilters])

  // Executes when the advanced search form is submitted
  const onAdvancedSearchHandle = values => {
    setAdvancedSearch(values)
    dispatch(getProvinceStock(values))
  }

  // Trigger export process when Export button is clicked
  const onExportClicked = () => {
    dispatch(exportProvinceStock(advancedSearch))
  }

  return (
    <React.Fragment>
      <Breadcrumbs title={"Province"} breadcrumbItem={"Dashboard"} />
      {/* Province Dashboard Component  */}
      <ProvinceDashboardComponent
        stocks={provinceStock?.data?.data?.provinceReports}
        allData={provinceStock?.data?.data}
        onAdvanceSearch={onAdvanceSearch}
        onCategoryChange={onCategoryChange}
        categories={categories}
        onExportClicked={onExportClicked}
        onAdvancedSearchHandle={onAdvancedSearchHandle}
      />
    </React.Fragment>
  )
}

export default ProvinceDashboard
